(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4175],{

/***/ 13406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_landing_Container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94964);
/* harmony import */ var _components_landing_Head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81519);
/* harmony import */ var _components_landing_Press__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71723);
/* harmony import */ var _data_press_items_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48379);
/* harmony import */ var _data_seo_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35546);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);







var LIGHTNING_DATA = _data_press_items_json__WEBPACK_IMPORTED_MODULE_3__.find(function (i) {
  return i.name === "lightning-network";
});

function LightningNetwork() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_landing_Head__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      SEO: _data_seo_json__WEBPACK_IMPORTED_MODULE_4__
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_landing_Container__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_landing_Press__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        item: LIGHTNING_DATA,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Lightning Network now gives Data Mynt merchants, partners and their customers a faster option for Bitcoin transactions at minimal cost."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "SAN FRANCISCO, CA, USA, April 14, 2022 /EINPresswire.com/ -- Data Mynt, the world\u2019s fastest growing cryptocurrency payment gateway, has launched support for its fourth major blockchain network in as many months, the Bitcoin Lightning Network. Data Mynt now facilitates seamless payments to and from all Lightning Network enabled wallets in addition to Polygon Network, Ethereum Mainnet, and Bitcoin network wallets and assets. Data Mynt merchants and partners, which are on schedule to number in the tens of thousands by the end of Q2 2022, now receive and send payments from all Lightning Network enabled wallets such as Cash App and Strike."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Favored by nation states such as El Salvador and household brandnames including Twitter, PayPal and Whole Foods, Bitcoin is the world\u2019s most widely used digital asset."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt is on pace to be the global leader in crypto payments by supporting all major blockchains, all enabled wallets and their owners' crypto-of-choice."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "The Data Mynt gateway enables merchants, funds, and enterprises to expand their payment options for their crypto customers, investments, and partners. At the same time, it reduces payment processing costs and eliminates frictions such as chargebacks and crypto price volatility."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            className: "text-gray-50",
            children: "\u201CEvery day, Bitcoin is less about a store of value and, arguably, the currency-of-choice for day-to-day utility,\u201C noted Data Mynt CEO Alex Christian. \u201CThe Lightning Network is the key to unlocking the user experience and scalability for BTC payments that the entire world was waiting for. \u201D \u201CData Mynt\u2019s leadership in adopting Lightning will help bring Bitcoin to the next billion people around the world,\u201D said Elizabeth Stark, CEO and Co-Founder at Lightning Labs."
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h6", {
          className: "text-black text-md",
          children: "About DataMynt"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt is a global crypto payment processing gateway. Its wallet, asset and blockchain-agnostic suite of solutions offer partners and merchants an omnichannel approach to receiving and sending on-chain crypto payments free from volatility, risks, and costs of traditional payment methods. The Data Mynt payment solution is also designed to streamline implementation via API, branded web page, iFrame and merchant app, while consistently delivering a seamless customer experience for hundreds of thousands of merchants. DataMynt.com"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h6", {
          className: "text-black text-md",
          children: "About Lightning Labs"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Lightning Labs is building the next generation of decentralized, resilient financial infrastructure. We believe systems based on cryptography, blockchains, and smart contracts will enhance financial cooperation around the world in unprecedented ways at scales both large and small. We have developed Lightning Network Daemon (lnd) the most advanced and most developer-friendly implementation of the Lightning Network protocol. Along with Neutrino, an open platform that enables users with mobile devices to conduct blockchain and Lightning Network transactions quickly and easily."
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (LightningNetwork);

/***/ }),

/***/ 26621:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/lightning-network",
      function () {
        return __webpack_require__(13406);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,6111,9774,2888,179], function() { return __webpack_exec__(26621); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);